<template>
      <section id="app_section" v-if="customizationLocal.app_section_availability" class="ratio_56 small-section pb-0 d-none d-sm-block">
    <div class="container-fluid p-0">
      <div class="row m-0">
                <div class="order_setting col-md-7 p-0"  v-if="customizationLocal.app_section_image_order">
          <div class="app-left-img">
            <img
              src="/images/footer/app.jpg"
              class="img-fluid w-100"
              alt="app"
            />
          </div>
        </div>
        <div class="col-md-5 p-0">
          <div class="app-right-content">
            <div>
              <div class="logo">
                <img
                  src="/images/footer/logo-large.png"
                  class="img-fluid"
                  alt="logo"
                />
              </div>
              <h2>{{ _T('get GoOrder app') }}</h2>
              <h3>{{ _T('Order what you want everywhere') }}</h3>
              <div class="store-btn">
                <!-- <svg class="mr-1" width="172" height="57" fill="none">
                  <use xlink:href="#playStoreBadge" />
                </svg> -->
                <svg width="172" height="57" fill="none">
                  <use xlink:href="#appStoreBadge" />
                </svg>
              </div>
            </div>
                    </div>
                </div>
                <div class="order_setting col-md-7 p-0" v-if="!customizationLocal.app_section_image_order">
                    <div class="app-left-img">
                        <img src="/images/footer/app.jpg" class="img-fluid w-100" alt="app">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppSection',
  computed: {
        ...mapGetters(["_T", "customizationLocal"])
    }
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .mr-1,
  .mx-1 {
    margin-left: 0.25rem !important;
    margin-right: unset;
  }
}
#app_section#d-none {
  display: none;
}
.app-right-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: linear-gradient(
    270.18deg,
    $light-border 0.12%,
    rgba(var(--color-light-border-source), 0) 99.86%
  );
  .logo {
    margin-bottom: $px48;
  }
  h2 {
    text-transform: capitalize;
    font-weight: bold;
    font-size: calc(
      #{$px20} + (40 - 20) * ((100vw - #{$px320}) / (1920 - 320))
    );
    line-height: calc(
      #{$px30} + (53 - 30) * ((100vw - #{$px320}) / (1920 - 320))
    );
    margin-bottom: $px4;
  }
  h3 {
    font-size: calc(
      #{$px18} + (22 - 18) * ((100vw - #{$px320}) / (1920 - 320))
    );
    font-weight: normal;
    line-height: calc(
      #{$px18} + (29 - 18) * ((100vw - #{$px320}) / (1920 - 320))
    );
    margin-bottom: $px62;
  }
}
@media (max-width: 1367px) {
  .app-right-content {
    h3 {
      margin-bottom: $px32;
    }
    .logo {
      margin-bottom: $px20;
      img {
        width: 36%;
      }
    }
  }
}
@media (max-width: 991px) {
  .app-right-content {
    h3 {
      margin-bottom: $px20;
    }
    .logo {
      margin-bottom: $px10;
      img {
        width: 30%;
      }
    }
  }
}
@media (max-width: 767px) {
  .app-right-content {
    padding: $px20;
    text-align: center;
    h3 {
      margin-bottom: $px15;
    }
    .store-btn {
      // img {
      //   width: 35%;
      // }
    }
  }
}
</style>
